<template>
	<div style="width: 100%;text-align: center; ">
		<tablea4 ref='box5'></tablea4>
	</div>
</template>
<script>
	import tablea4 from './temp.vue';
	export default{
		components:{tablea4},
		mounted(){
			this.$refs.box5.getpdfdetail(this.$route.query.id)

		}
	}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// src/views/inspectDraw/business/expert/report.vue